import api from '../services/api';

const CRYPTO_META = {
  bitcoin: { id: 'bitcoin', symbol: 'BTC' },
  btc: { id: 'bitcoin', symbol: 'BTC' },
  ethereum: { id: 'ethereum', symbol: 'ETH' },
  eth: { id: 'ethereum', symbol: 'ETH' },
  tether: { id: 'tether', symbol: 'USDT' },
  usdt: { id: 'tether', symbol: 'USDT' },
  'usd tether': { id: 'tether', symbol: 'USDT' },
  'usd coin': { id: 'usd-coin', symbol: 'USDC' },
  usdc: { id: 'usd-coin', symbol: 'USDC' },
  bnb: { id: 'binancecoin', symbol: 'BNB' },
  binance: { id: 'binancecoin', symbol: 'BNB' },
  binancecoin: { id: 'binancecoin', symbol: 'BNB' },
  solana: { id: 'solana', symbol: 'SOL' },
  sol: { id: 'solana', symbol: 'SOL' },
  ripple: { id: 'ripple', symbol: 'XRP' },
  xrp: { id: 'ripple', symbol: 'XRP' },
  cardano: { id: 'cardano', symbol: 'ADA' },
  ada: { id: 'cardano', symbol: 'ADA' },
  dogecoin: { id: 'dogecoin', symbol: 'DOGE' },
  doge: { id: 'dogecoin', symbol: 'DOGE' },
  tron: { id: 'tron', symbol: 'TRX' },
  trx: { id: 'tron', symbol: 'TRX' },
  toncoin: { id: 'toncoin', symbol: 'TON' },
  ton: { id: 'toncoin', symbol: 'TON' },
  litecoin: { id: 'litecoin', symbol: 'LTC' },
  ltc: { id: 'litecoin', symbol: 'LTC' },
  polkadot: { id: 'polkadot', symbol: 'DOT' },
  dot: { id: 'polkadot', symbol: 'DOT' },
  avalanche: { id: 'avalanche-2', symbol: 'AVAX' },
  avax: { id: 'avalanche-2', symbol: 'AVAX' },
  chainlink: { id: 'chainlink', symbol: 'LINK' },
  link: { id: 'chainlink', symbol: 'LINK' },
};

const CACHE_TTL_MS = 5 * 60 * 1000;
let memoryCache = null;

export function cryptoMeta(name) {
  const key = String(name || '').trim().toLowerCase();
  return CRYPTO_META[key] || { id: key, symbol: String(name || '').trim().toUpperCase() || 'TOKEN' };
}

export async function fetchCryptoUsdPrices() {
  if (memoryCache?.prices && memoryCache?.savedAt && Date.now() - memoryCache.savedAt < CACHE_TTL_MS) {
    return memoryCache.prices;
  }

  const { data: prices } = await api.get('/crypto/prices', { skipAuthRedirect: true });
  memoryCache = { prices, savedAt: Date.now() };
  return prices;
}

export function formatTokenAmount(amount, cryptoName) {
  const value = Number(amount);
  const { symbol } = cryptoMeta(cryptoName);
  if (!Number.isFinite(value)) return `- ${symbol}`;
  return `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 8 }).format(value)} ${symbol}`;
}

export function formatApproxUsd(amount, cryptoName, prices) {
  const value = Number(amount);
  const { id } = cryptoMeta(cryptoName);
  const price = prices?.[id]?.usd;
  if (!Number.isFinite(value) || !Number.isFinite(price)) return null;
  return `~${new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value * price)}`;
}
